export const LOCALIZATION_TOKEN = 'LOCALIZATION';

export const LOCALIZATION_API_PATHS = {
    'localization': `/i18n/`
};
